import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, Modal } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import search from "../../../assets/images/search-lg.svg";
import NormalCardHeader from "../../../Common/CardHeader/NormalCardHeader";
import { deleteOneSize, getAllSize } from "../../../../redux/size/action";
import CommonPagination from "../../../Common/Pagination/CommonPagination";
import DeleteSize from "./DeleteSize";
import * as XLSX from "xlsx";
import axiosInstance from "../../../../redux/api";
import { usePermissions } from "../../../../Hooks/usePermissions";
import { MENU, PERMISSION } from "../../../../lib/permissions";




const SizeList = () => {
  const { hasAction } = usePermissions();
  const [params, setParams] = useState({
    page: 1,
    search_key: "",
    status: "",
  });
  const [searchtext, setSearchtext] = useState(params?.search_key || "");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const { t } = useTranslation();
  const [openFilter, setOpenFilter] = useState(false);
  const [modal, setModal] = useState(false);
  const [currentComponent, setCurrentComponent] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const sizeData = useSelector((state) => state.reusableSlice.sizeListData) || [];


  const addComponent = () => {
    navigate("/addsize");
  };

  const updateComponent = (id) => {
    navigate(`/upadtesize/${id}`);
  };

  useEffect(() => {
    dispatch(getAllSize(params));
  }, [dispatch, params]);

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      setParams((prevParams) => ({
        ...prevParams,
        search_key: searchtext,
        page: 1,
      }));
    }, 500);
    return () => clearTimeout(debounceTimeout);
  }, [searchtext]);

  const deleteComponent = () => {
    if (currentComponent && currentComponent.id) {
      dispatch(deleteOneSize(currentComponent?.id));
    } else {
      console.error("No valid ID found for the component to delete.");
    }
  };

  const filteredItems = params.status
    ? sizeData.filter((item) => item.status === parseInt(params.status))
    : sizeData;

  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
  const currentPageItems = filteredItems.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  //  csv file convert
  const handleExportSizes = async (e) => {
    e.preventDefault();
  
    const filterParams = {
      ...params,
      page: "", 
    };

    try {
      const response = await axiosInstance.post(`size/get_all`, filterParams  );
  
      const sizeData = response?.data?.response || [];
  
      if (!sizeData.length) return;
  
      const header = [["Sl", "Name", "AR Name", "Status"]];
      const data = sizeData.map((item, index) => [
        index + 1,
        item.name,
        item.ar_name,
        item.status === 1 ? "Active" : item.status === 2 ? "Inactive" : "",
      ]);
  
      const worksheet = XLSX.utils.aoa_to_sheet(header);
      XLSX.utils.sheet_add_aoa(worksheet, data, { origin: "A2" });
  
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Size List");
  
      XLSX.writeFile(workbook, "SizeList.xlsx");
    } catch (error) {
      console.error("Size Export Error:", error);
    }
  };
  
  // permission delete
  const canDelete = hasAction(MENU.CATALOGUE, PERMISSION.DELETE);

      
      

  return (
    <div className="card-head order-card">
      <div className="sub-head">
        <h4>Size List</h4>
      </div>
      {/* <div
        onClick={() => setOpenFilter(false)}
        className={openFilter ? `overlay show` : "overlay"}
      ></div> */}
      <NormalCardHeader
        params={params}
        setParams={setParams}
        addmodel={addComponent}
        search={search}
        setOpenFilter={setOpenFilter}
      />
      <div className="table-category mt-3 ">
        <div className="table-first-top d-flex justify-content-between align-items-center">
          
          <div className="d-flex justify-content-end align-items-center table-right product-wrap">
            Filter by
            <select
              onChange={({ target }) =>
                setParams((prevParams) => ({
                  ...prevParams,
                  status: target.value,
                  page: 1,
                }))
              }
            >
              <option value="">All</option>
              <option value="1">Active</option>
              <option value="2">Inactive</option>
            </select>
            <button className="btn btn-primary" onClick={handleExportSizes}>
    Export CSV
  </button>
          </div>
        </div>
        <div className="table-sec table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Sno</th>
                <th scope="col">Name</th>
                <th scope="col">Ar Name</th>
                <th scope="col">Status</th>
                <th scope="col" className="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {currentPageItems.length > 0 ? (
                currentPageItems.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                    <td>{item?.name}</td>
                    <td>{item?.ar_name}</td>
                    <td
                        style={{
                          color:
                            item.status === 1
                              ? "#12b812"
                              : item.status === 2
                              ? "red"
                              : "inherit",
                        }}
                      >
                        <div
                          className=""
                          style={{
                            backgroundColor:
                              item.status === 1
                                ? "#16d11630"
                                : item.status === 2
                                ? "#ff000026"
                                : "inherit",
                            padding: "3px 25px",
                            borderRadius: "50px",
                            textAlign: "center",
                            width: "fit-content",
                          }}
                        >
                          {item.status === 1
                            ? "Active"
                            : item.status === 2
                            ? "Inactive"
                            : ""}
                        </div>
                      </td>
                    <td>
                    <div class="dropdown d-flex justify-content-center">
                          <button
                            class="dropdown-action-btn dropdown-toggle"
                            type="button"
                            id="dropdownMenuButton"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            Action
                          </button>
                          <div
                            class="dropdown-menu"
                            aria-labelledby="dropdownMenuButton"
                          >
                            <a
                              class="dropdown-item"
                              onClick={() => updateComponent(item.id)}
                            >
                              Edit
                            </a>
                            {canDelete && (
                              <a
                                class="dropdown-item"
                                onClick={() => {
                                  setModal(true);
                                  setCurrentComponent(item);
                                }}
                              >
                                Delete
                              </a>
                            )}   
                          </div>
                        </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="11" className="text-center">
                    No size found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <CommonPagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
      </div>
      <Modal isOpen={modal} toggle={() => setModal((state) => !state)}>
        <DeleteSize
          setModal={setModal}
          currentComponent={currentComponent}
          deleteComponent={deleteComponent}
        />
      </Modal>
    </div>
  );
};

export default SizeList;
